
<div
	ref="wysiwyg-wrapper"
	class="flow-text-section"
	:contenteditable="editable"
	:highlight="highlight"
	:highlightState="highlightState"
	:style="{ webkitLineClamp: noOfLines }"
	@blur="updateValue()"
	@keypress="handleKeypress($event)"
	@click="handleClick($event)"
	@keyup="handleKeyup($event)"
	@paste="handlePaste($event)"
	@focus="handleFocus($event)"
>
	<!--eslint-disable-next-line vue/no-v-html-->
	<div v-if="encodeHTML" ref="text-container" :class="'text-editor ' + textClasses">
		{{ innerValue }}
	</div>
	<div v-else ref="text-container" :class="'text-editor ' + textClasses" v-html="innerValue" />
</div>
